/* eslint-disable no-unused-vars */

import React, { memo, useEffect, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import AppBar from '@components/app-bar';
import Home from '@components/home';
import Icon from '@components/icon-component';

import { filterActions } from '@redux/slices/filters';
import { getAppDispatch } from '@utilities/dispatch.util';
import useWindowDimensions from '@hooks/useWindowDimensions';

import style from './styles.module.scss';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const assetNotFoundError = searchParams.get('assetNotFound') || false;
  const dispatch = getAppDispatch?.();
  const { width } = useWindowDimensions();
  useEffect(() => {
    dispatch?.(filterActions.setTaskFilters(null));
    dispatch?.(filterActions.setSitesFilters(null));
    dispatch?.(filterActions.setEquipmentsFilters(null));
    dispatch?.(filterActions.setPipelinesFilters(null));
    dispatch?.(filterActions.setStructuresFilters(null));
  }, []);

  useEffect(() => {
    const indicator = document.querySelector('.onlineOfflineIndicator');
    const header = document.querySelector('#header');
    const appBar = document.querySelector('.appBar');

    if (indicator && header && width < 768) {
      indicator.remove();
      header.appendChild(indicator);
    }
    if (indicator && appBar && width >= 768) {
      indicator.remove();
      appBar.insertBefore(indicator, appBar.firstChild);
    }
  }, [width]);

  const iconName = useMemo(() => {
    return assetNotFoundError ? 'bookmark-error-screen' : 'broken-bulb';
  }, [assetNotFoundError]);

  return (
    <div>
      <div className={`md:ml-24 ${style.dashboardContainer} removeScrollbar`} id="dashboard">
        <div>
          <div className={style.errorBoundary}>
            <div className={style.center}>
              <Icon
                name={iconName}
                className={assetNotFoundError ? style.ladyError : style.brokenBulb}
              />
              <div className={style.content}>
                <p className={style.oh}>
                  {' '}
                  {assetNotFoundError ? 'Dang. This one wasn’t downloaded.' : 'Uh oh.'}
                </p>
                <p className={style.wrong}>
                  {assetNotFoundError
                    ? 'This task or asset wasn’t downloaded as part of your cached dataset.'
                    : 'Something went wrong on our end.'}
                </p>

                {assetNotFoundError && (
                  <div className={style.descriptionList}>
                    <p>This could be because:</p>
                    <ul>
                      <li>of a recent permissions change,</li>
                      <li>it’s not in your cached area(s),</li>
                      <li>the task is no longer assigned to you,</li>
                      <li>or the task is not within your task download window.</li>
                    </ul>
                    <p
                      style={{
                        marginTop: '16px'
                      }}
                    >
                      To set area and download settings, visit{' '}
                      <span className={style.underlineInfo}>Data Caching</span> in{' '}
                      <span className={style.underlineInfo}>Settings</span>.
                    </p>
                  </div>
                )}
              </div>
              <div className={`op-view-work-by-column ${style.button} `}>
                <Link className={`op-structure button-link`} to={`/dashboard`}>
                  <span>Go back Home</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ErrorPage);
